export default __webpack_public_path__ + "static/newsroom-header-option-18cba091bab3402d755eabc8719d219c.jpg";